import { lazy } from "react";

export { APPLICATION_PATH } from "./application-path";
export const ApplicationPage = lazy(() => import("./application"));
export { ToApplication } from "./to-application";
